import React from 'react';
import styled from 'styled-components';
import {
  DetailTitle,
  DetailTitleSec,
  InfoWrap,
} from '@pages/Posting/PostingDetail/sideType/DetailStyle';
import PostingInfoSec from '@pages/Posting/PostingDetail/sideType/PostingInfoSec';
import HashtagSec from '@template/HashtagSec/HashtagSec';
import BackToListBtn from '@components/dataEntry/button/BackBtn/BackToListBtn';
import DetailPageControlSec from '@template/ControlSec/DetailPageControlSec';
import MusicButton from '@template/MusicPlayer/MusicBtn';
import Color from '@styles/Color';
import { motion } from 'framer-motion';
import IconButton from '@components/dataEntry/button/IconButton';
import { useEditPermission } from '@hooks/usePermission';

const variants = {
  initial: { opacity: 0, y: -50 },
  hidden: {
    opacity: 0,
    y: -50,
    transition: {
      duration: 0.2,
    },
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 0.6,
    },
  },
  exit: {
    opacity: 0,
    y: -50,
    transition: {
      duration: 0.2,
    },
  },
};

const WideHeaderWrapper = styled(motion.div)`
  width: 100%;
  height: 40px;
  padding: 0 16px;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;

  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${Color.BLUE_GRAY_8};
  backdrop-filter: blur(12px);

  .title {
    font-size: 17px;
    color: ${Color.BLUE_GRAY_1};
  }
`;

const TitleSec = styled.div`
  display: flex;
  align-items: center;
`;

type Props = {
  // data: IpostingItem | IphotocardPostingItem;
  data: any;
  handleEdit: () => void;
  handleDelete: () => void;
  collectionPath: string;
  handleBack?: () => void;
  showTitle?: boolean;
  showBackBtn?: boolean;
  showWide?: boolean;
  showActionBar?: boolean;
  showMusic?: boolean;
};

function PostingTitleSec({
  data,
  handleEdit,
  handleDelete,
  handleBack,
  collectionPath,
  showTitle = false,
  showBackBtn = false,
  showWide,
  showActionBar,
  showMusic,
}: Props) {
  if (!data) return null;

  const editPermission = useEditPermission({ authorUid: data.authorUid });

  if (showWide) {
    return (
      <WideHeaderWrapper
        initial="initial"
        animate={showActionBar ? 'show' : 'hidden'}
        exit="exit"
        variants={variants}
      >
        <TitleSec style={{ gap: 8 }}>
          <BackToListBtn
            showText={false}
            shape="transparent"
            IconColor={Color.BLUE_GRAY_1}
            handleClick={() => {
              if (handleBack) handleBack();
            }}
          />
          <span className="title">{data.title}</span>
        </TitleSec>
        <TitleSec>
          {editPermission && (
            <>
              <IconButton
                shape="default"
                icon="Edit14"
                iconColor={Color.BLUE_GRAY_1}
                onClick={handleEdit}
              />
              <IconButton
                shape="default"
                icon="Trash14"
                iconColor={Color.RED_2}
                onClick={handleDelete}
              />
            </>
          )}

          <MusicButton color={Color.BLUE_GRAY_1} isShow={showMusic} />
        </TitleSec>
      </WideHeaderWrapper>
    );
  } else {
    return (
      <DetailTitleSec>
        {showBackBtn && (
          <BackToListBtn
            handleClick={() => {
              if (handleBack) handleBack();
            }}
          />
        )}

        {showTitle ? (
          <>
            <DetailTitle>{data.title}</DetailTitle>
            <p className="subTitle">{data.subTitle} </p>
            <InfoWrap>
              {!showBackBtn && <PostingInfoSec data={data} />}
              <DetailPageControlSec
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                authorUid={data.authorUid || ''}
                editHistory={(data as any).editHistory}
              />
            </InfoWrap>
          </>
        ) : (
          <InfoWrap>
            <DetailPageControlSec
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              authorUid={data.authorUid || ''}
              editHistory={(data as any).editHistory}
            />
          </InfoWrap>
        )}

        {showTitle && data.hashtagIdList && (
          <HashtagSec
            collectionPath={collectionPath}
            hashtagIdList={data.hashtagIdList}
          />
        )}
      </DetailTitleSec>
    );
  }
}

export default PostingTitleSec;
